import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { CreatePageCollectionRequest } from "@shopexperts/shared";

export function useCreatePageCollection() {
  const api = useApi();
  const queryClient = useQueryClient();
  const toaster = useToaster();

  return useMutation({
    mutationFn: (data: CreatePageCollectionRequest) =>
      api.admin.pages.createCollection({ body: data }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "page-collections"] });
      toaster.create({
        title: "Collection created successfully",
        type: "success",
      });
    },
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "An error occurred while creating the collection.";

      toaster.create({
        title: "Failed to create collection",
        description: errorMessage,
        type: "error",
      });
    },
  });
}
